module.exports = __webpack_public_path__ + "assets/icons/quick-haul.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/quick-haul.png
// module id = ./src/styles/icons/sidemenu/quick-haul.png
// module chunks = 0